import { render } from "./DateRoom.vue?vue&type=template&id=130bf42e&scoped=true"
import script from "./DateRoom.vue?vue&type=script&lang=js"
export * from "./DateRoom.vue?vue&type=script&lang=js"

import "./DateRoom.vue?vue&type=style&index=0&id=130bf42e&lang=stylus&scoped=true"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130bf42e"]])

export default __exports__